/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'call-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M23.555 20.794l-1.721 1.72a5.062 5.062 0 0 1-6.45.595 62.665 62.665 0 0 1-7.594-5.898 62.67 62.67 0 0 1-5.899-7.594 5.063 5.063 0 0 1 .595-6.451l1.72-1.72a1.52 1.52 0 0 1 2.15 0L9.224 4.31a1.52 1.52 0 0 1 0 2.15L7.988 7.696a1.013 1.013 0 0 0-.147 1.247 27.345 27.345 0 0 0 3.532 4.684 27.35 27.35 0 0 0 4.684 3.532 1.013 1.013 0 0 0 1.247-.147l1.235-1.235a1.52 1.52 0 0 1 2.15 0l2.866 2.867a1.52 1.52 0 0 1 0 2.15z"/>'
  }
})
